/**
 * Instruction Templates & Blocks
 *
 * Templates organized by business type for the Agent Instructions Modal.
 * Each template provides pre-filled instruction text with placeholders.
 * Blocks are reusable instruction sections users can add individually.
 */

export const INSTRUCTION_TEMPLATES = {
  automotive: {
    label: 'Loja de Veículos',
    icon: '🚗',
    text: `## Financiamento
- Formas aceitas: [CDC bancário, financiamento próprio, consórcio]
- Entrada mínima: [ex: 30% do valor do veículo]
- Parcelas: até [ex: 60x]
- Quando perguntarem sobre financiamento, sempre pergunte primeiro o valor de entrada disponível

## Troca / Retoma
- [Aceitamos / Não aceitamos] veículos usados como entrada
- Solicitar do cliente: marca, modelo, ano e quilometragem
- Avaliação é [presencial / online com fotos]

## Negociação
- Desconto máximo sem aprovação do gerente: [ex: 5%]
- Se insistirem em desconto maior: [ex: ofereça acessórios como alternativa]

## Test Drive
- [Disponível / Não disponível]
- Agendar com [ex: 24h] de antecedência
- Documentos necessários: [ex: CNH válida]`,
  },

  clinic: {
    label: 'Clínica / Consultório',
    icon: '🏥',
    text: `## Consultas e Procedimentos
- Tipos de atendimento: [ex: consulta, retorno, exame, procedimento]
- Duração média: [ex: 30 minutos]
- Primeira consulta requer: [ex: documento com foto e cartão do convênio]

## Convênios e Pagamento
- Convênios aceitos: [liste os convênios]
- Valor da consulta particular: [ex: R$ 250,00]
- Formas de pagamento: [ex: dinheiro, PIX, cartão de crédito/débito]

## Orientações ao Paciente
- Preparo para consulta/exame: [ex: jejum de 8h para exames de sangue]
- Política de cancelamento: [ex: cancelar com 24h de antecedência]
- Em caso de emergência: [ex: ligar para (11) 99999-9999]`,
  },

  ecommerce: {
    label: 'E-commerce / Loja',
    icon: '🛒',
    text: `## Envio e Entrega
- Prazo de entrega: [ex: 3 a 7 dias úteis]
- Frete grátis acima de: [ex: R$ 199,00]
- Regiões atendidas: [ex: todo o Brasil]

## Trocas e Devoluções
- Prazo para troca: [ex: até 30 dias após o recebimento]
- Condições: [ex: produto sem uso, com etiqueta e embalagem original]
- Como solicitar: [ex: enviar mensagem com número do pedido]

## Pagamento
- Formas aceitas: [ex: PIX, cartão de crédito até 12x, boleto bancário]
- Desconto à vista (PIX): [ex: 5%]

## Promoções
- [Descreva promoções ativas ou regras de cupom]`,
  },

  realestate: {
    label: 'Imobiliária',
    icon: '🏠',
    text: `## Imóveis Disponíveis
- Tipos: [ex: apartamentos, casas, terrenos, comerciais]
- Regiões atendidas: [ex: Zona Sul de São Paulo]
- Para buscar imóvel, perguntar: tipo, região, faixa de preço e número de quartos

## Financiamento Imobiliário
- Bancos parceiros: [ex: Caixa, Itaú, Bradesco]
- Entrada mínima: [ex: 20% do valor do imóvel]
- Aceita FGTS: [Sim / Não]

## Visitas
- Agendar com [ex: 24h] de antecedência
- Visitas disponíveis: [ex: segunda a sábado, 9h às 18h]
- Documentos para proposta: [ex: RG, CPF, comprovante de renda]`,
  },

  beauty: {
    label: 'Salão / Estética',
    icon: '💇',
    text: `## Serviços
- Serviços disponíveis: [ex: corte, coloração, manicure, design de sobrancelha]
- Tabela de preços: [liste os principais ou diga onde consultar]

## Agendamento
- Horário de funcionamento: [ex: segunda a sábado, 9h às 19h]
- Agendar com antecedência mínima de: [ex: 2 horas]
- Política de atraso: [ex: tolerância de 15 minutos]

## Cancelamento
- Cancelar com no mínimo: [ex: 2 horas de antecedência]
- [Cobrar / Não cobrar] taxa por no-show`,
  },

  education: {
    label: 'Curso / Escola',
    icon: '📚',
    text: `## Cursos Disponíveis
- Cursos: [liste os cursos ou categorias]
- Modalidade: [presencial / online / híbrido]
- Duração: [ex: 6 meses, 40 horas]

## Matrícula
- Período de matrícula: [ex: janeiro a março]
- Documentos necessários: [ex: RG, CPF, comprovante de residência]
- Valor: [ex: R$ 150,00/mês ou R$ 1.500,00 à vista]
- Desconto para pagamento à vista: [ex: 10%]

## Certificado
- [Emite / Não emite] certificado
- Requisitos: [ex: 75% de presença e nota mínima 7]`,
  },

  restaurant: {
    label: 'Restaurante / Delivery',
    icon: '🍕',
    text: `## Cardápio
- [Descreva as categorias ou diga onde consultar o cardápio]
- Opções especiais: [ex: vegetariano, vegano, sem glúten]

## Delivery
- Raio de entrega: [ex: até 5km]
- Pedido mínimo: [ex: R$ 25,00]
- Taxa de entrega: [ex: R$ 5,00 ou grátis acima de R$ 50,00]
- Tempo médio de entrega: [ex: 30 a 45 minutos]

## Reservas
- [Aceita / Não aceita] reservas
- Capacidade: [ex: até 60 pessoas]
- Para grupos acima de [ex: 10 pessoas], entrar em contato por telefone`,
  },

};

export const INSTRUCTION_BLOCKS = [
  {
    id: 'pricing',
    label: 'Política de preços',
    icon: '💰',
    text: `## Política de Preços
- [Descreva sua política de preços]
- Descontos disponíveis: [ex: 5% à vista, 10% para pagamento anual]
- Condições especiais: [ex: preço diferenciado para grupos]`,
  },
  {
    id: 'payment',
    label: 'Formas de pagamento',
    icon: '💳',
    text: `## Formas de Pagamento
- [ex: PIX, cartão de crédito/débito, boleto, dinheiro]
- Parcelamento: [ex: até 12x sem juros no cartão]
- Desconto à vista: [ex: 5% no PIX]`,
  },
  {
    id: 'restrictions',
    label: 'O que NÃO fazer',
    icon: '🚫',
    text: `## Restrições
- NUNCA [ex: invente informações sobre produtos/serviços]
- NUNCA [ex: forneça dados pessoais de funcionários]
- NUNCA [ex: prometa prazos que não pode cumprir]`,
  },
  {
    id: 'required_info',
    label: 'Informações a coletar',
    icon: '📋',
    text: `## Informações Obrigatórias
- Sempre coletar: [ex: nome completo, telefone, e-mail]
- Para orçamento: [ex: tipo de serviço, prazo desejado]
- Para agendamento: [ex: data, horário, tipo de atendimento]`,
  },
  {
    id: 'faq',
    label: 'Perguntas frequentes',
    icon: '❓',
    text: `## Perguntas Frequentes
- Pergunta: [ex: Qual o horário de funcionamento?]
  Resposta: [ex: Segunda a sexta, das 8h às 18h]

- Pergunta: [ex: Vocês entregam em todo o Brasil?]
  Resposta: [ex: Sim, entregamos para todo o Brasil via Correios e transportadoras]`,
  },
  {
    id: 'promotions',
    label: 'Promoções e descontos',
    icon: '🏷️',
    text: `## Promoções Ativas
- [Descreva promoções vigentes]
- Cupom de desconto: [ex: PRIMEIRA10 para 10% na primeira compra]
- Validade: [ex: até 31/03/2026]`,
  },
  {
    id: 'script',
    label: 'Script de atendimento',
    icon: '📝',
    text: `## Script de Atendimento
- Ao iniciar conversa: [ex: cumprimentar e perguntar como pode ajudar]
- Ao finalizar: [ex: agradecer e perguntar se precisa de mais algo]
- Tom da conversa: [ex: amigável mas profissional]`,
  },
  {
    id: 'custom',
    label: 'Bloco livre',
    icon: '✏️',
    text: `## [Título do bloco]
- [Escreva suas instruções aqui]`,
  },
];
